<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>

<div [ngClass]="{ 'ml-0': user.role === 'OutSideOrg' }">
    <div *ngIf="user.role === 'OutSideOrg'" class="ml-4 d-flex justify-content-between">
        <a class="logo" href="https://test.trinityairmedical.com/">
            <img class="app-logo logo-mini" src="../../../assets/img/Trinity_3.0_HorizonalLogo.jpg" />
        </a>
        <div class="d-flex mt-3 mr-3" style="width: 12%">
            <button class="message-icon mr-0 mt-1 mb-3 mr-3" (click)="download()">
                <i class="fa fa-download fa-lg" aria-hidden="true"></i>
            </button>
            <ngx-select-dropdown
                id="timeZoneDropDown"
                class="time-zone-dropdown"
                name="timeZone"
                style="width: 98%"
                tabindex="0"
                [config]="timezoneConfig"
                [multiple]="false"
                [options]="timezones"
                [(ngModel)]="selectedTimezone"
                (change)="selectTimeZone($event)"
            ></ngx-select-dropdown>
        </div>
    </div>
    <section class="content-header">
        <div class="pull-left box-tools">
            <button
                *ngIf="user.role != 'OutSideOrg'"
                class="plus-icon"
                style="margin-top: 0px; background: transparent !important"
                title="Go Back"
                type="submit"
                (click)="goBack()"
            >
                <i class="fa fa-chevron-circle-left fa-lg" aria-hidden="true"></i>
            </button>
        </div>
        <ngx-select-dropdown
            *ngIf="user.role == 'OutSideOrg'"
            id="timeZoneDropDown2"
            name="timeZone"
            style="width: 98%"
            tabindex="0"
            [config]="timezoneConfig"
            [multiple]="false"
            [options]="timezones"
            [(ngModel)]="selectedTimezone"
            (change)="selectTimeZone($event)"
        >
        </ngx-select-dropdown>
        <h1 class="heading" [ngClass]="{ 'margin-left-30': user.role != 'OutSideOrg' }">
            <strong>Itinerary</strong>
        </h1>
    </section>

    <section class="content">
        <div class="card-layout card">
            <div class="row">
                <div class="col-lg-12 d-flex justify-content-between" style="flex-wrap: wrap">
                    <h4>SUMMARY</h4>
                    <span *ngIf="!isInternalReadOnly">
                        <span
                            *ngIf="
                                user.role != 'Customer Admin' &&
                                user.role != 'Customer Coordinator' &&
                                user.role != 'Driver' &&
                                user.role != 'Vendor Admin' &&
                                user.role != 'Vendor Driver' &&
                                user.role != 'Accounting' &&
                                user.role != 'OutSideOrg' &&
                                ServiceList.srStatus != serviceRequestStatusEnum.COMPLETED &&
                                ServiceList.srStatus != serviceRequestStatusEnum.CANCELLED_WITH_ZERO_MOVEMENT &&
                                ServiceList.srStatus != serviceRequestStatusEnum.CANCELLED_WITH_POSITIVE_MOVEMENT
                            "
                            class="pull-right"
                        >
                            <span
                                id="edit_itinerary"
                                class="cursorPointer text-color text-color1 mr-3"
                                (click)="createItinerary(serviceRequestId)"
                            >
                                <a href="{{ url }}/itinerary/{{ serviceRequestId }}">
                                    <button
                                        id="close"
                                        class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn py-2 buttons"
                                        style="font-size: 14px"
                                        type="submit"
                                    >
                                        Edit Itinerary
                                    </button>
                                </a>
                            </span>
                        </span>
                        <span *ngIf="user.role == 'Accounting'" class="pull-right">
                            <span id="generate_invoice" class="cursorPointer text-color text-color1 mr-3">
                                <a
                                    style="display: contents; text-decoration: none"
                                    [queryParams]="{ groupedInvoice: false, srId: serviceRequestId, memberId: user.memberId }"
                                    [routerLink]="['/service-request-invoice']"
                                >
                                    <button
                                        id="close"
                                        class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn py-2 buttons"
                                        style="font-size: 14px"
                                        type="submit"
                                    >
                                        Generate Invoice
                                    </button></a
                                >
                            </span>
                        </span>

                        <span
                            *ngIf="
                                user.role != 'Customer Admin' &&
                                user.role != 'Customer Coordinator' &&
                                user.role != 'Driver' &&
                                user.role != 'Vendor Admin' &&
                                user.role != 'Accounting' &&
                                user.role != 'OutSideOrg' &&
                                user.role != 'Vendor Driver' &&
                                ServiceList.srStatus != serviceRequestStatusEnum.COMPLETED &&
                                ServiceList.srStatus != serviceRequestStatusEnum.CANCELLED_WITH_ZERO_MOVEMENT &&
                                ServiceList.srStatus != serviceRequestStatusEnum.CANCELLED_WITH_POSITIVE_MOVEMENT
                            "
                            class="pull-right"
                            style="margin-right: 5px"
                        >
                            <span
                                id=" edit_service_request"
                                class="cursorPointer text-color text-color1 mr-3"
                                title="Edit Service Request"
                                (click)="editRequest(serviceRequestId)"
                            >
                                <!--<i class="fa fa-pencil-square mr-3"></i>Edit Detail-->
                                <a href="{{ url }}/edit-service-request/{{ serviceRequestId }}">
                                    <button
                                        id="close"
                                        class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn py-2 buttons"
                                        style="font-size: 14px"
                                        type="submit"
                                    >
                                        Edit
                                    </button></a
                                >
                            </span>
                        </span>

                        <span>
                            <button
                                *ngIf="
                                    user.role != 'Customer Admin' &&
                                    user.role != 'Driver' &&
                                    user.role != 'Vendor Admin' &&
                                    user.role != 'Vendor Driver' &&
                                    user.role != 'Accounting' &&
                                    user.role != 'OutSideOrg' &&
                                    user.role != 'Customer Coordinator'
                                "
                                class="message-icon pull-right mr-2"
                                data-target="#ShowAssignMessage"
                                data-toggle="modal"
                                title="Show Tagged Message"
                            >
                                <i class="fa fa-tag fa-sm" aria-hidden="true"></i>
                            </button>
                        </span>

                        <span
                            *ngIf="user.role == 'Executive Admin' || user.role == 'Coordinator' || user.role == 'Management'"
                            class="pull-right mr-3"
                        >
                            <span id="checklist" class="cursorPointer text-color text-color1 mr-3">
                                <button
                                    class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn py-2 px-0 buttons"
                                    style="font-size: 14px"
                                    title="View Checklist Details"
                                    type="submit"
                                    (click)="openCheckListDetails()"
                                >
                                    <i class="fa fa-list-ul cursorPointer" aria-hidden="true"></i>
                                </button>
                            </span>
                        </span>
                        <span
                            *ngIf="user.role == 'Executive Admin' || user.role == 'Coordinator' || user.role == 'Management'"
                            class="hidden-xs pull-right mr-2"
                        >
                            <span id="callflow" class="cursorPointer text-color text-color1 mr-3">
                                <a
                                    href="{{ url }}/{{ callFlowDetailsEndPoint }}/{{ serviceTypeId }}/{{
                                        ServiceList.customerInfo.businessUnitId
                                    }}/{{ ServiceList.tripId }}"
                                    target="_blank"
                                >
                                    <button
                                        class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn py-2 px-0 buttons"
                                        style="font-size: 14px"
                                        title="View Call Flow Details"
                                        type="submit"
                                    >
                                        <i class="fa fa-info cursorPointer pl-2 pr-2" aria-hidden="true"></i>
                                    </button>
                                </a>
                            </span>
                        </span>
                    </span>
                </div>
                <div class="col-lg-12">
                    <hr class="hr-class mt-0" />
                </div>
                <div class="col-lg-9 col-xs-12 line-right">
                    <div>
                        <div class="row serviceInfo">
                            <div class="col-lg-6">
                                <div>
                                    <b>Customer</b>
                                    <span
                                        *ngIf="
                                            user.role != 'Customer Admin' &&
                                            user.role != 'Driver' &&
                                            user.role != 'Vendor Admin' &&
                                            user.role != 'Vendor Driver' &&
                                            user.role != 'Accounting' &&
                                            user.role != 'OutSideOrg'
                                        "
                                        class="margin-left-10"
                                        data-target="#FeedbackFile"
                                        data-toggle="modal"
                                        title="Add Notes"
                                        (click)="updateNotesType('customerNotes')"
                                        ><i
                                            class="fa fa-exclamation-circle theme-color cursorPointer"
                                            aria-hidden="true"
                                            title="Customer Notes"
                                        ></i
                                    ></span>
                                </div>
                                <div>
                                    <div class="margin-top-5">
                                        <span class="font-weight-600 margin-right-10"><i class="fa fa-user fa-lg theme-color"></i> </span
                                        >{{ customerSelected?.customerName }}
                                    </div>
                                </div>
                                <hr class="hr-class mb-3" />
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div>
                                    <b>Phone</b>
                                </div>
                                <div class="margin-top-5">
                                    <a
                                        *ngIf="!isInternalReadOnly"
                                        class="phonenumberlink"
                                        href="tel:+1{{ ServiceList.customerInfo?.phoneNumber }}"
                                    >
                                        <i class="fa fa-phone fa-lg theme-color margin-r-5" aria-hidden="true"></i>
                                        {{ ServiceList.customerInfo.phoneNumber | phoneNumberPipe }}<br />
                                    </a>
                                    <span *ngIf="isInternalReadOnly">
                                        <i class="fa fa-phone fa-lg theme-color margin-r-5" aria-hidden="true"></i>
                                        {{ ServiceList.customerInfo.phoneNumber | phoneNumberPipe }}<br />
                                    </span>
                                </div>
                                <hr class="hr-class mb-3" />
                            </div>
                            <div *ngIf="ServiceList.customerInfo.subCustomer?.name" class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Sub Customer:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">
                                        <span>
                                            {{ ServiceList.customerInfo.subCustomer.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Service Request No:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">
                                        <span
                                            [ngClass]="{
                                                badge: ServiceList.serviceInfo.priority,
                                                highPriorityBadge: ServiceList.serviceInfo.priority,
                                            }"
                                        >
                                            {{ ServiceList.tripId }}
                                        </span>
                                        <span
                                            *ngIf="
                                                user.role == 'Executive Admin' ||
                                                user.role == 'Coordinator' ||
                                                user.role == 'Management' ||
                                                user.role == 'Customer Admin' ||
                                                user.role == 'Accounting' ||
                                                user.role == 'Customer Coordinator' ||
                                                user.role == 'Vendor Coordinator' ||
                                                user.role == 'Vendor Admin'
                                            "
                                            class="badge ml-2 mb-1"
                                            [ngClass]="{
                                                'region-east': ServiceList.serviceInfo.region == 'East',
                                                'region-west': ServiceList.serviceInfo.region == 'West',
                                                'region-central': ServiceList.serviceInfo.region == 'Central',
                                                'region-lifeSource': ServiceList.serviceInfo.region == 'LifeSource',
                                            }"
                                        >
                                            {{ ServiceList.serviceInfo.region }}
                                        </span>
                                        <span *ngIf="ServiceList.serviceRequestLinkId" class="badge linkId ml-2 mb-1">
                                            <span class="d-flex align-items-center cursorArrow">
                                                <img class="width-11" alt="" src="../../../assets/img/linkSR.png" />
                                                <span>
                                                    {{ ServiceList.serviceRequestLinkId }}
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Lights and Sirens:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ serviceisCode3 }}</div>
                                </div>
                            </div>
                            <div *ngIf="isAdmin" class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <label class="col-lg-5 col-sm-6 col-xs-6">Catering:</label>
                                <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.catering ? 'Yes' : 'No' }}</div>
                            </div>
                            <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">UNOS NO:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.unos }}</div>
                                </div>
                            </div>
                            <div *ngIf="start_Time != ''" class="col-lg-6 p-0 col-sm-12 col-sm-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">
                                        {{
                                            ServiceList.serviceInfo.schedulingType !== schedulingTypeEnum.HotStandbyTime
                                                ? 'Pickup Time:'
                                                : 'Hot Standby:'
                                        }}
                                    </label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ start_Time | localDate: timeZone }}</div>
                                </div>
                            </div>
                            <div *ngIf="scheduledArrivalTime" class="col-lg-6 p-0 col-sm-12 col-sm-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Scheduled Arrival Time:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ scheduledArrivalTime | localDate: timeZone }}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Additional Equipment:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">
                                        {{
                                            ServiceList?.serviceInfo?.transmedics == null
                                                ? 'NA'
                                                : ServiceList?.serviceInfo?.transmedics == true
                                                  ? ServiceList.serviceInfo.additionalEquipmentType
                                                  : 'No'
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Device Registration Number:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">
                                        {{ ServiceList.serviceInfo?.deviceRegistrationNumber }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Service type:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.serviceType }}</div>
                                    <div
                                        *ngIf="ServiceList.serviceInfo.serviceSubType?.[0] != ''"
                                        class="col-lg-6 col-md-5 col-sm-5 col-xs-6 ml-3"
                                    >
                                        <img src="../../assets/img/subcat.png" style="height: 22px; width: 25px" />
                                        <div class="sub-service type">
                                            {{ ServiceList.serviceInfo.serviceSubType }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Created by:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList?.createdBy }}</div>
                                </div>
                            </div>
                            <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Created on:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ createdOn | localDate: timeZone }}</div>
                                </div>
                            </div>
                            <div *ngIf="canShowOrTime(ServiceList.serviceInfo.serviceType)" class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">OR time:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">
                                        <ng-container *ngIf="ortime != null; else elseBlockORTime">
                                            {{ ortime | localDate: timeZone }}
                                        </ng-container>
                                        <ng-template #elseBlockORTime> TBD </ng-template>
                                    </div>
                                </div>
                            </div>

                            <div
                                *ngIf="ServiceList.serviceInfo.matchId != '' && ServiceList.serviceInfo.matchId != null"
                                class="col-lg-6 p-0 col-sm-12 col-xs-12"
                            >
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Match ID:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.matchId }}</div>
                                </div>
                            </div>

                            <div
                                *ngIf="ServiceList.serviceInfo.tissueId != '' && ServiceList.serviceInfo.tissueId != null"
                                class="col-lg-6 p-0 col-sm-12 col-xs-12"
                            >
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Tissue ID:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.tissueId }}</div>
                                </div>
                            </div>
                            <div
                                *ngIf="ServiceList.serviceInfo.internalReferenceId || ServiceList.serviceInfo.internalReferenceId === ''"
                                class="col-lg-6 p-0 col-sm-12 col-xs-12"
                            >
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Internal Reference ID:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">
                                        {{ ServiceList.serviceInfo.internalReferenceId }}
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="ServiceList.serviceInfo.donorType" class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <label class="col-lg-5 col-sm-6 col-xs-6">Donor Type:</label>
                                <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.donorType }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div *ngIf="estimatedSourceTime != null" class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6 text-success">Preliminary Outbound D2D:</label>
                                    <div *ngIf="estimatedSourceTime != 0" class="col-lg-7 col-sm-6 col-xs-6 pr-0">
                                        {{ estimatedSourceTime | hourMinConvertion }}
                                        <span *ngIf="ServiceList.serviceInfo?.outBoundETA != null" class="ml-2"><b>ETA</b></span
                                        ><span class="ml-2">{{ ServiceList.serviceInfo?.outBoundETA | localDate: timeZone }}</span>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="actualSourceTime != null" class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Actual Outbound D2D:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">
                                        <span *ngIf="actualSourceTime != 0">{{ actualSourceTime | hourMinConvertion }}</span>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="estimatedDestinationTime != null" class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6 text-danger">Preliminary Inbound D2D:</label>
                                    <div *ngIf="estimatedDestinationTime != 0" class="col-lg-7 col-sm-6 col-xs-6 pr-0">
                                        {{ estimatedDestinationTime | hourMinConvertion }}
                                        <span *ngIf="ServiceList.serviceInfo?.inBoundETA != null" class="ml-2"><b>ETA</b></span
                                        ><span class="ml-2">{{ ServiceList.serviceInfo?.inBoundETA | localDate: timeZone }}</span>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="actualDestinationTime != null" class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Actual Inbound D2D:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">
                                        <span *ngIf="actualDestinationTime != 0"> {{ actualDestinationTime | hourMinConvertion }}</span>
                                    </div>
                                </div>
                            </div>
                            <div
                                *ngIf="
                                    ServiceList.serviceInfo.mediGoTrackerNumber != null && ServiceList.serviceInfo.mediGoTrackerNumber != ''
                                "
                                class="col-lg-6 p-0 col-sm-12 col-xs-12"
                            >
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">MediGO Tracker Number:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.mediGoTrackerNumber }}</div>
                                </div>
                            </div>
                            <div
                                *ngIf="ServiceList.serviceInfo.airSpaceJobID != null && ServiceList.serviceInfo.airSpaceJobID != ''"
                                class="col-lg-6 p-0 col-sm-12 col-xs-12"
                            >
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Air Space Job ID:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.airSpaceJobID }}</div>
                                </div>
                            </div>
                            <div
                                *ngIf="
                                    ServiceList.serviceInfo.airSpacetrackingID != null && ServiceList.serviceInfo.airSpacetrackingID != ''
                                "
                                class="col-lg-6 p-0 col-sm-12 col-xs-12"
                            >
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Air Space Tracking ID:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.airSpacetrackingID }}</div>
                                </div>
                            </div>
                            <div *ngIf="ServiceList.coordinatorName != '  '" class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                <div>
                                    <label class="col-lg-5 col-sm-6 col-xs-6">Assigned Coordinator:</label>
                                    <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.coordinatorName }}</div>
                                </div>
                            </div>
                            <ng-container *ngIf="ServiceList.serviceInfo.serviceType === serviceRequestTypeEnum.NEXT_FLIGHT_OUT">
                                <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                    <div>
                                        <label class="col-lg-5 col-sm-6 col-xs-6">Airway Bill</label>
                                        <div class="col-lg-7 col-sm-6 col-xs-6">{{ ServiceList.serviceInfo.airwayBill }}</div>
                                    </div>
                                </div>
                                <div class="col-lg-6 p-0 col-sm-12 col-xs-12">
                                    <div>
                                        <label class="col-lg-5 col-sm-6 col-xs-6">Tracking Link</label>
                                        <a target="_blank" [href]="ServiceList.serviceInfo.trackingLink">{{
                                            ServiceList.serviceInfo.trackingLink
                                        }}</a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <hr class="hr-class" />
                        <div class="row form-group col-md-12">
                            <ngu-carousel
                                #srcdesCarousel
                                [dataSource]="carouselTileItems"
                                [inputs]="carouselTile"
                                (carouselLoad)="carouselTileLoad()"
                            >
                                <ngu-tile *nguCarouselDef="let item; let i = index">
                                    <div class="tile">
                                        <div class="carousel-title">{{ item.Name }}</div>
                                        <div class="carousel-text">{{ item.Address1 }}</div>
                                        <div class="carousel-text">{{ item.Address2 }}</div>
                                        <div *ngIf="item.ContactName != null" class="carousel-text">
                                            <span class="font-weight-600 margin-right-10">
                                                <i class="fa fa-user fa-lg theme-color"></i></span
                                            >{{ item.ContactName }}
                                        </div>
                                        <div *ngIf="item.ContactName != null" class="carousel-text">
                                            <span class="font-weight-600 margin-r-5">
                                                <i class="fa fa-phone fa-lg theme-color"></i>
                                            </span>
                                            <a *ngIf="!isInternalReadOnly" class="phonenumberlink" href="tel:+1{{ item.Contact }}">
                                                {{ item.Contact | phoneNumberPipe }}
                                            </a>
                                            <span *ngIf="isInternalReadOnly">
                                                {{ item.Contact | phoneNumberPipe }}
                                            </span>
                                        </div>
                                    </div>
                                </ngu-tile>
                                <button *ngIf="carouselList.length > 2" class="leftRs" NguCarouselPrev>&lt;</button>
                                <button *ngIf="carouselList.length > 2" class="rightRs" NguCarouselNext>&gt;</button>
                            </ngu-carousel>
                        </div>
                    </div>
                </div>
                <div class="row specialInstructionWithTeamRow">
                    <div class="row col-lg-3 col-xs-12 p-0 pl-3">
                        <div class="col-lg-12 margin-bottom-10">
                            <div>
                                <b>Special Instruction ({{ SpecialInstructionCount }})</b>
                            </div>
                        </div>
                        <div id="instruction-containerId" class="div-height pb-4">
                            <div *ngFor="let si of specialInstructions; let i = index">
                                <div class="col-lg-12">
                                    <div class="d-flex">
                                        <label>Category:</label>
                                        <div class="margin-left-7">{{ si?.category }}</div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="d-flex">
                                        <label>Instruction:</label>
                                        <div class="col-lg-12 col-xs-12 pl-1 pr-1">{{ si?.instruction }}</div>
                                        <hr class="horizontal-line-style margin-left-10 margin-right-10 si-horizontal" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr
                            *ngIf="
                                ServiceList.serviceInfo.serviceType == this.serviceTypeNames.team ||
                                ServiceList.serviceInfo.serviceType == this.serviceTypeNames.handCarry
                            "
                            class="hr-class m-3"
                        />
                    </div>

                    <div
                        *ngIf="
                            ServiceList.serviceInfo.serviceType == this.serviceTypeNames.team ||
                            ServiceList.serviceInfo.serviceType == this.serviceTypeNames.handCarry
                        "
                        class="team-height"
                    >
                        <div class="row col-lg-3 col-xs-12 mb-0 pb-0 team-member-div">
                            <div class="col-lg-12 mb-0 pb-0">
                                <div>
                                    <b>Team Member ({{ ServiceList.serviceInfo.teamDetails.length }})</b><br />
                                    <img
                                        *ngIf="ServiceList.serviceInfo.teamDetails.length != 0"
                                        src="../../assets/img/subcat.png"
                                        style="height: 22px; width: 25px"
                                    />
                                </div>
                                <ng-container>
                                    <div id="team-detail-containerId" class="team-member-detamil-height">
                                        <div>
                                            <div *ngFor="let teamDetails of ServiceList.serviceInfo.teamDetails">
                                                <div class="ml-4 mb-2">
                                                    <span *ngIf="user.businessUnitId != internalMemberBusinessUnitId" class="cursorPointer"
                                                        ><b>{{ teamDetails.memberName }}</b></span
                                                    >
                                                    <span
                                                        *ngIf="user.businessUnitId == internalMemberBusinessUnitId"
                                                        class="cursorPointer"
                                                        data-target="#memberDetail"
                                                        data-toggle="modal"
                                                        title="Show Member Details"
                                                        ><b (click)="openTeamMemberDetailsModal(teamDetails)">{{
                                                            teamDetails.memberName
                                                        }}</b></span
                                                    >
                                                    <span *ngIf="user.role != 'OutSideOrg'"
                                                        >,&nbsp;{{ teamDetails.phoneNumber | phoneNumberPipe }},<br />{{
                                                            teamDetails.memberAddress
                                                        }}</span
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div
                        *ngIf="
                            ServiceList.serviceInfo.serviceType === serviceTypeNames.handCarry &&
                            ServiceList.serviceInfo.temporaryTeamMembers.length
                        "
                        class="temporary-team-details"
                    >
                        <div class="row col-lg-3 col-xs-12 p-0 pl-5">
                            <div class="col-lg-12 mb-0 pb-0 top-red-line">
                                <div>
                                    <b>Temporary Team Member ({{ ServiceList.serviceInfo.temporaryTeamMembers.length }})</b><br />
                                    <img
                                        *ngIf="ServiceList.serviceInfo.temporaryTeamMembers.length"
                                        class="sub-cat-img"
                                        src="../../assets/img/subcat.png"
                                    />
                                </div>

                                <ng-container>
                                    <div class="temporary-team-member-container">
                                        <div *ngFor="let item of ServiceList.serviceInfo.temporaryTeamMembers">
                                            <div class="ml-4 mb-2">
                                                <span class="name"
                                                    ><b>{{ item?.fullName }} ,</b></span
                                                >
                                                <span class="phone">{{ item.phone | phoneNumberPipe }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-layout card">
            <div class="row">
                <div class="col-lg-12">
                    <div class="col-lg-4">
                        <h4>LEG DETAILS</h4>
                    </div>
                    <div class="col-lg-3 col-xs-6 mt-3">
                        <span class="pt-3 cursorPointer"
                            ><a class="theme-color" (click)="showHideAll(showHideText)"
                                ><b>{{ showHideText }}</b></a
                            ></span
                        >
                    </div>
                    <div
                        *ngIf="user.role != 'Vendor Admin' && user.role != 'Vendor Coordinator'"
                        class="col-lg-4 mt-3 pull-right cursorPointer"
                    >
                        <span class="pull-right cursorPointer">
                            <a id="openFullMap" class="text-color" (click)="onShowFullMapClick()">
                                <span>Show Full Map</span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <hr class="hr-class" />
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-5 margin-bottom-10 firstcol scrollbarView">
                        <div class="form-group">
                            <div class="row serviceInfo">
                                <div class="col-md-12">
                                    <div *ngFor="let leg of legList; let i = index" class="row leg-container form-group">
                                        <div
                                            class="row d-flex cursorPointer"
                                            style="padding: 0px 15px"
                                            (click)="showLegdetails(i + 1, 'Bidid')"
                                        >
                                            <div class="pull-left box-tools theme-color cursorPointer">
                                                <a *ngIf="!HideMe[i + 1]" title="Show">
                                                    <i
                                                        id="icon_Bidid{{ leg.legId }}"
                                                        class="fa fa-chevron-down filter-options theme-color margin-top-5"
                                                    ></i>
                                                </a>
                                                <a *ngIf="HideMe[i + 1]" title="Hide">
                                                    <i
                                                        id="icon_Bidid{{ leg.legId }}"
                                                        class="fa fa-chevron-up filter-options theme-color margin-top-5"
                                                    ></i>
                                                </a>
                                            </div>
                                            <div class="form-group col-md-9 p-0" style="display: inline-flex">
                                                <span class="dot leg-detail-dot" [ngClass]="directionColor(leg?.direction)">
                                                    {{ i + 1 }}
                                                </span>
                                                <span *ngIf="HideMe[i + 1]"
                                                    ><b class="bold">{{ leg?.destination }}</b></span
                                                >
                                                <span *ngIf="!HideMe[i + 1]"
                                                    ><span class="mr-3"
                                                        ><b class="bold">{{ leg?.origin }}</b></span
                                                    ><i class="fa fa-arrow-right mr-3"></i
                                                    ><span
                                                        ><b class="bold">{{ leg?.destination }}</b></span
                                                    ></span
                                                >
                                            </div>

                                            <div class="form-group col-md-2 status-width margin-top-5 heading-font-size">
                                                <span
                                                    *ngIf="leg.transportType == 'Ground'"
                                                    class="label label-success badge-status badge-status-width mt-1"
                                                    [ngClass]="{
                                                        'landedCompleted-class': leg.status == 'Completed',
                                                        'enroute-class': leg.status == 'Enroute',
                                                        'on-scene-status-class': leg.status == 'On-Scene',
                                                        'not_started-class': leg.status == 'Not Started',
                                                        'picked-Up-class': leg.status == 'Picked-Up',
                                                        'jobDone-class': leg.status == 'Job Done',
                                                        'driverDone-class': leg.status == 'Driver Done',
                                                    }"
                                                >
                                                    {{ leg?.status }}</span
                                                >

                                                <span
                                                    *ngIf="leg.transportType == 'Air'"
                                                    class="label label-success badge-status badge-status-width mt-1"
                                                    [ngClass]="{
                                                        'landedCompleted-class': leg.status == 'Landed',
                                                        'enroute-class': leg.status == 'Onboarded',
                                                        'wheels-up-air-status-class': leg.status == 'Wheels Up',
                                                        'not_started-class': leg.status == 'Not Started',
                                                        'jobDone-class': leg.status == 'Job Done',
                                                        'driverDone-class': leg.status == 'Driver Done',
                                                        'reposition-status-class': leg.status == 'Repositioning',
                                                        'on-scene-status-class': leg.status == 'In Position',
                                                        'on-standby-status-class': leg.status == 'On Standby',
                                                    }"
                                                >
                                                    {{ leg?.status }}
                                                </span>
                                            </div>
                                        </div>

                                        <div class="container-fluid" [hidden]="!showLegDetail[i + 1]">
                                            <div class="form-group w-100 margin-left-25 pickup-hospital">
                                                <b>{{ leg?.origin }}</b>
                                            </div>

                                            <div class="form-group w-100 margin-left-25 pickup-loc">
                                                {{ leg?.originAddress }} {{ leg?.originAddressLocation }}
                                            </div>
                                            <div class="form-group w-100 margin-left-25">
                                                <i
                                                    *ngIf="leg?.transportType == 'Ground' && !leg?.isLightsAndSirens"
                                                    class="fa fa-car fa-lg"
                                                ></i>
                                                <img
                                                    *ngIf="leg?.transportType == 'Ground' && leg?.isLightsAndSirens"
                                                    alt="light and sirens"
                                                    src="../../../assets/img/lights and sirens1.png"
                                                    width="30"
                                                />
                                                <i *ngIf="leg?.transportType == 'Air'" class="fa fa-plane fa-lg"></i>
                                                <span class="margin-left-7"></span>
                                                <span>{{ leg?.direction | titlecase }}</span>
                                                <span class="margin-left-7"></span>
                                                <span
                                                    *ngIf="
                                                        user.role != 'OutSideOrg' &&
                                                        leg.outBoundReposition != null &&
                                                        leg.outBoundReposition != ''
                                                    "
                                                    id="ob-repo-popover{{ i }}"
                                                    class="mr-2 cursorPointer"
                                                    data-placement="auto right"
                                                    data-toggle="popover"
                                                    title="OB Repo : {{ leg.outBoundReposition }}"
                                                    [attr.data-content]="
                                                        leg.obEstimatedBlockHours | numberToHourMinuteConversion: 'OB Estimated Block Hours'
                                                    "
                                                    (click)="togglePopOver()"
                                                >
                                                    <img alt="Plane Departure Image" height="20" width="30" [src]="plane_departure_img" />
                                                </span>
                                                <span
                                                    *ngIf="
                                                        user.role != 'OutSideOrg' &&
                                                        leg.inBoundReposition != null &&
                                                        leg.inBoundReposition != ''
                                                    "
                                                    id="ib-repo-popover{{ i }}"
                                                    class="mr-2 cursorPointer"
                                                    data-placement="auto right"
                                                    data-toggle="popover"
                                                    title="IB Repo : {{ leg.inBoundReposition }}"
                                                    [attr.data-content]="
                                                        leg.ibEstimatedBlockHours | numberToHourMinuteConversion: 'IB Estimated Block Hours'
                                                    "
                                                    (click)="togglePopOver()"
                                                >
                                                    <img alt="Plane Departure Image" height="20" width="30" [src]="plane_arrival_img" />
                                                </span>
                                                <a
                                                    *ngIf="user.role != 'Vendor Admin' && user.role != 'Vendor Coordinator'"
                                                    id="openMap"
                                                    class="margin-left-25 cursorPointer text-color"
                                                    title="Show Map"
                                                    (click)="drawLegMap(leg?.originId, leg?.destinationId, leg?.transportType, leg?.legId)"
                                                >
                                                    Show Map
                                                </a>
                                                <a
                                                    *ngIf="user.role != 'OutSideOrg'"
                                                    id="openMap"
                                                    class="margin-left-25 cursorPointer text-color"
                                                    data-target="#FeedbackFile"
                                                    data-toggle="modal"
                                                    title="Show Notes"
                                                    (click)="openAddFileNotesPopup(leg.legId); updateNotesType('legNotes')"
                                                >
                                                    Show Notes
                                                </a>
                                            </div>
                                            <div *ngIf="leg.deliveryNote" class="form-group w-100 margin-left-25">
                                                <label>Delivery Note :</label>
                                                <div style="line-height: 1.4; word-wrap: break-word">
                                                    {{ leg.deliveryNote }}
                                                </div>
                                            </div>
                                            <div class="form-group w-100 margin-left-25">
                                                <b>{{ leg?.destination }}</b>
                                            </div>
                                            <div class="form-group w-100 margin-left-25 receive-loc">
                                                {{ leg?.destinationAddress }} {{ leg?.destinationAddressLocation }}
                                            </div>
                                            <div class="form-group w-100 margin-left-25 startdate">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <div class="row_container">
                                                                    <div
                                                                        class="title_container table-data-width"
                                                                        style="width: 50% !important"
                                                                    >
                                                                        <div class="carousel-title">Planned</div>
                                                                        <table style="width: auto !important">
                                                                            <tr class="line-height-2">
                                                                                <td class="table_inner_icon text-left">
                                                                                    <strong>Pickup: </strong>&nbsp;
                                                                                </td>
                                                                                <td class="table_inner_detail">
                                                                                    {{ leg?.plannedStartTime | localDate: timeZone }}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="table_inner_icon text-left line-height-2">
                                                                                    <strong>Dropoff: </strong>
                                                                                </td>
                                                                                <td class="table_inner_detail">
                                                                                    {{ leg?.plannedEndTime | localDate: timeZone }}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="table_inner_icon text-left line-height-2">
                                                                                    <strong>Duration: </strong>
                                                                                </td>
                                                                                <td class="table_inner_detail pl-1">
                                                                                    {{ legPlannedDuration[i] }}
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </div>
                                                                    <div
                                                                        class="title_container table-data-width"
                                                                        style="width: 50% !important"
                                                                    >
                                                                        <div class="carousel-title">Actual</div>
                                                                        <table style="width: auto !important">
                                                                            <tr class="line-height-2">
                                                                                <td class="table_inner_icon text-left">
                                                                                    <strong>Pickup:</strong>
                                                                                </td>
                                                                                <td class="table_inner_detail">
                                                                                    {{ leg?.actualStartTime | localDate: timeZone }}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="table_inner_icon text-left line-height-2">
                                                                                    <strong>Dropoff: </strong>
                                                                                </td>
                                                                                <td class="table_inner_detail">
                                                                                    <!-- {{leg?.destinationDateTime| localDate : timeZone}}</td> -->

                                                                                    {{ leg?.actualEndTime | localDate: timeZone }}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="table_inner_icon text-left line-height-2">
                                                                                    <strong>Duration: </strong>
                                                                                </td>
                                                                                <td class="table_inner_detail pl-1">
                                                                                    {{ legActualDuration[i] }}
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div *ngIf="leg.transportType == 'Ground'">
                                                <div class="row_container row_container_provider_detail">
                                                    <div
                                                        class="form-group w-100 margin-left-25 pickup-hospital"
                                                        style="width: 50% !important"
                                                    >
                                                        <label style="line-height: 1.2em">Provider:</label>
                                                        {{
                                                            leg.provider.providerName == null && leg.isAssigned == true
                                                                ? 'Internal'
                                                                : leg.isAssigned == true
                                                                  ? leg.provider.providerName
                                                                  : '-'
                                                        }}
                                                    </div>
                                                    <div style="width: 50% !important">
                                                        <label style="line-height: 1.2em">Driver Name:</label>
                                                        {{ leg.provider.memberName }}
                                                    </div>
                                                </div>
                                                <div class="row_container row_container_provider_detail">
                                                    <div
                                                        class="form-group w-100 margin-left-25 pickup-hospital"
                                                        style="width: 50% !important"
                                                    >
                                                        <label style="line-height: 1.2em">Make:</label>{{ leg.make }}
                                                    </div>

                                                    <div style="width: 50% !important">
                                                        <label style="line-height: 1.2em">Model:</label>
                                                        {{ leg.model }}
                                                    </div>
                                                </div>
                                                <div class="row_container row_container_provider_detail">
                                                    <div
                                                        class="form-group w-100 margin-left-25 pickup-hospital"
                                                        style="width: 50% !important"
                                                    >
                                                        <label style="line-height: 1.2em">Plate No.:</label> {{ leg.tailNumber }}
                                                    </div>
                                                    <div
                                                        *ngIf="
                                                            user.role != 'OutSideOrg' &&
                                                            user.role != 'Customer Coordinator' &&
                                                            user.role != 'Customer Admin'
                                                        "
                                                        style="width: 50% !important"
                                                    >
                                                        <label style="line-height: 1.2em">Provider Contact:</label>
                                                        {{ leg.provider.providerContact }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div *ngIf="leg.transportType == 'Air'">
                                                <div class="row_container">
                                                    <div
                                                        class="form-group w-100 margin-left-25 pickup-hospital"
                                                        style="width: 50% !important"
                                                    >
                                                        <label style="line-height: 1.2em">Provider:</label>
                                                        {{
                                                            leg.provider.providerName == null && leg.isAssigned == true
                                                                ? 'Internal'
                                                                : leg.isAssigned == true
                                                                  ? leg.provider.providerName
                                                                  : '-'
                                                        }}
                                                    </div>
                                                    <div style="width: 50% !important">
                                                        <label style="line-height: 1.2em">Driver Name:</label>
                                                        {{ leg.provider.memberName }}
                                                    </div>
                                                </div>
                                                <div class="row_container">
                                                    <div
                                                        class="form-group w-100 margin-left-25 pickup-hospital"
                                                        style="width: 50% !important"
                                                    >
                                                        <label style="line-height: 1.2em"> Tail#:</label>
                                                        <span class="cursorPointer hoverPoniter" style="color: #a82b41 !important">
                                                            <a
                                                                class="flat-butt flat-danger-butt flat-danger-grad-butt cursorPointer msg-icon"
                                                                href="https://flightaware.com/live/flight/{{ leg.tailNumber }}"
                                                                hreflang="en-us"
                                                                target="_blank"
                                                            >
                                                                <i class="fa fa-plane" aria-hidden="true" style="padding: 2px"></i>
                                                                {{ leg.tailNumber }}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div
                                                        *ngIf="
                                                            user.role != 'OutSideOrg' &&
                                                            user.role != 'Customer Coordinator' &&
                                                            user.role != 'Customer Admin'
                                                        "
                                                        style="width: 50% !important"
                                                    >
                                                        <label style="line-height: 1.2em">Provider Contact:</label>
                                                        {{ leg.provider.providerContact }}
                                                    </div>
                                                </div>
                                            </div>

                                            <br />
                                            <div *ngIf="leg?.assignedLegDetails != null" class="d-flex">
                                                <div class="form-group w-100 margin-left-25 pickup-hospital">
                                                    <i class="fa fa-user fa-lg theme-color margin-r-5" aria-hidden="true"></i>
                                                    {{ leg?.assignedLegDetails.driverName }}
                                                </div>

                                                <div class="form-group w-100 pickup-hospital">
                                                    <i class="fa fa-phone fa-lg theme-color margin-r-5" aria-hidden="true"></i>
                                                    <a class="phonenumberlink" href="tel:+1{{ leg?.provider.providerContact }}">{{
                                                        leg?.provider.providerContact | phoneNumberPipe
                                                    }}</a>
                                                </div>
                                            </div>
                                            <div *ngIf="leg?.assignedLegDetails != null">
                                                <br /><span class="margin-left-25">
                                                    <span *ngIf="leg?.transportType == 'Ground'">
                                                        <b>Plate Number : </b
                                                        ><span class="text-color">{{ leg?.assignedLegDetails.vehicleNumber }}</span>
                                                    </span>
                                                    <span *ngIf="leg?.transportType == 'Air'"
                                                        ><b>Tail Number : </b
                                                        ><a
                                                            class="text-color"
                                                            href="https://flightaware.com/live/flight/{{
                                                                leg.assignedLegDetails.vehicleNumber
                                                            }}"
                                                            hreflang="en-us"
                                                            target="_blank"
                                                            >{{ leg?.assignedLegDetails.vehicleNumber }}</a
                                                        ></span
                                                    >
                                                    <!-- {{leg?.assignedLegDetails.vehicleNumber}} -->
                                                    <!-- {{leg?.transportType == 'Ground'?'Plate Number :':'#Tail Number :'}} -->
                                                </span>
                                            </div>
                                            <br />
                                            <!-- <div class="form-group w-100 margin-left-25 pickup-hospital" *ngIf="leg?.note!==undefined">
                        <label style="line-height:1.2em">Notes:</label> {{leg?.Note}}
                      </div> -->
                                            <br />
                                        </div>
                                        <hr class="horizontal-line-style" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 second-col">
                        <div class="form-group">
                            <div *ngIf="user.role != 'Vendor Admin' && user.role != 'Vendor Coordinator'" class="row">
                                <div class="form-group col-md-12">
                                    <div id="mapContainer" #mapContainer style="width: 100%; height: 665px; position: relative"></div>
                                    <div class="mapControl">
                                        <b>Distance:</b> {{ distance }}
                                        <br />
                                        <b>Duration:</b> {{ duration }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-note-feedback-file
            *ngIf="user.role != 'OutSideOrg' && isServiceRequestLoaded"
            [fromPage]="'Preview'"
            [isCatering]="ServiceList.serviceInfo.catering"
            [serviceRequestId]="serviceRequestId"
            [modelVersion]="ServiceList.modelVersion"
        >
        </app-note-feedback-file>
    </section>
</div>

<app-note-file-modal
    *ngIf="notesType == 'legNotes'"
    [businessUnitId]="legId"
    [fromPage]="'Perview'"
    [FromPreviewItinerary]="false"
    [header]="user?.role != 'Customer Admin' && user?.role != 'Customer Coordinator' ? 'Add Notes' : 'Notes'"
    (isCloseModel)="noteModelClose()"
>
</app-note-file-modal>

<app-note-file-modal
    *ngIf="notesType == 'customerNotes'"
    [businessUnitId]="customerSelectedId"
    [fromPage]="'Perview'"
    [FromPreviewItinerary]="true"
    [header]="user?.role != 'Customer Admin' && user?.role != 'Customer Coordinator' ? 'Add Notes' : 'Notes'"
>
</app-note-file-modal>

<div id="memberDetail" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header content-header">
                <button class="close close-btn" aria-label="Close" data-dismiss="modal" type="button">
                    <i class="fa fa-close fa-md"></i>
                </button>
                <h4 class="modal-title">Team Member Details</h4>
            </div>
            <div class="modal-body">
                <div class="card-layout card pb-1">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="mt-2">Name: </label>
                                <div class="form-control mt-3">{{ teamMemberDetails.memberName }}</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="mt-2">Phone Number: </label>
                                <div class="form-control mt-3">{{ teamMemberDetails.phoneNumber | phoneNumberPipe }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="mt-2">DOB: </label>
                                <div class="form-control mt-3">{{ teamMemberDetails.dob }}</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="form-group">
                                    <label class="mt-2">Weight: </label>
                                    <div class="form-control mt-3">{{ teamMemberDetails.weight }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="mt-2">Gender: </label>
                                <div class="form-control mt-3">{{ teamMemberDetails.gender }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="mt-2">Address: </label>
                                <textarea class="form-control mt-3" readonly>{{ teamMemberDetails.memberAddress }}</textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
